import axios from 'axios'
import { getStoredWbToken, clearStoredWbToken } from '../utils/wbToken'

const API_URL = import.meta.env.VITE_API_URL || '/api/v1'

export const  api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Интерцептор для добавления WB-токена (заменяет собой авторизацию)
api.interceptors.request.use((config) => {
  const token = getStoredWbToken()
  if (token && !config.headers['X-WB-Token']) {
    config.headers['X-WB-Token'] = token
  }
  return config
})

// Интерцептор для обработки ошибок
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearStoredWbToken()
      window.location.href = '/'
    }
    return Promise.reject(error)
  }
)